import script from "./LampEffect.vue?vue&type=script&lang=ts&setup=true"
export * from "./LampEffect.vue?vue&type=script&lang=ts&setup=true"

import "./LampEffect.vue?vue&type=style&index=0&id=0b06d2e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b06d2e5"]])

export default __exports__